enum PubSubTopicEnum
{
	ADMIN = "/admin",
	PUBLIC = "/public",
	USER = "/user",
	TIMER = "/timer",
}

export default PubSubTopicEnum;
